export const localeRoot = "email_hub.landing_page";
